import { MOCK_BLACKLIST_ACCESS_ATTEMPTS_REPOSITORY } from "./blacklistWorker";

export default async function getBlacklistedAccessAttempts(workerId: number): Promise<Array<BlacklistedAccessAttempt>> {
  try {
    return MOCK_BLACKLIST_ACCESS_ATTEMPTS_REPOSITORY.get(workerId) || [];
  } catch (error) {
    throw error;
  }
}